import { Button, Modal, Form, InputGroup, FormControl } from 'react-bootstrap';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import StudentService from '../../service/studentService'
import StudentCourseService from '../../service/studentCourseService'
import useToken from '../../App/useToken';

import './SearchStudentModal.css'

export default function SearchStudentModal({ getStudentCourse, showAddStudentModal, setShowAddStudentModal, errorNotify, successNotify, courseId, majorCourseName }) {
    const { getToken } = useToken();
    const token = getToken();
    const [airforceId, setAirforceId] = useState();
    const [searchResult, setSearchResult] = useState();
    const [isSearchLoading, setIsSearchLoading] = useState(false);
  
    const handleClose = () => {
      setShowAddStudentModal(false);
      setSearchResult();
    }

    const handleOnSearch = async e => {
      e.preventDefault();
      setIsSearchLoading(true);
      const studentService = new StudentService()
      const res = await studentService.getStudentByAirforceId(airforceId, majorCourseName, token);
      if (res.type == 'error') {
        errorNotify(typeof res.message == 'string' ? res.message : 'เกิดข้อผิดพลาด');
        setIsSearchLoading(false);
      } else {
        setSearchResult(res.data)
        setIsSearchLoading(false);
      }
      
    }

    const handleOnStudentCourseSave = async e => {
      e.preventDefault();
      const studentCourseService = new StudentCourseService()
      const res = await studentCourseService.createStudentCourseByCourseId({ ...searchResult, courseId }, token)
      console.log('res :>> ', res);
      if (res?._id) {
        successNotify('บันทึกสำเร็จ');
        getStudentCourse();
      } else {
        errorNotify(res.message)
      }
      document.getElementById("searchTextField").focus();
    }

    return (
      <>
        <Modal
            show={TextTrackCueList}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ค้นหา/เพิ่มผู้เรียน/อัปเดตข้อมูล</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleOnSearch} className='search-student'>
                <InputGroup className="mb-3">
                  <FormControl
                    required
                    placeholder="Airforce Id"
                    id='searchTextField'
                    onChange={e => setAirforceId(e.target.value)}
                    type='number'
                  />
                </InputGroup> 
                <Button variant="primary" type="submit">
                  <>{ isSearchLoading && <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> }ค้นหา</>
                </Button>
              </Form>
              {searchResult && <div className='search-result'>
                <span>ชื่อ: {searchResult.rankAbbrName}{searchResult.fullName}</span><br/>
                <span>อายุ: {searchResult.age}</span><br/>
                <span>เหล่า: {searchResult?.pme_data?.ARM_ABBR_NAME || '-'}</span><br/>
                <span>ตำแหน่ง: {searchResult?.pme_data?.POS_ORG_ABBR_NAME || '-'}</span><br/>
                <span>สังกัด: {searchResult?.pme_data?.ARM_ABBR_NAME || '-'}</span><br/>
                <span>สายวิทยาการ: {searchResult?.spcName}</span><br/>
                <span>ลชทอ.หลัก: {searchResult?.pme_data?.SKILL_NO_01 || '-'}</span><br/>
                <span>ลชทอ.รอง1: {searchResult?.pme_data?.SKILL_NO_02 || '-'}</span><br/>
                
              </div>}
              
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                ปิด
              </Button>
              <Button variant="primary" onClick={handleOnStudentCourseSave}>บันทึก</Button>
            </Modal.Footer>
        </Modal>
      </>
    );
}